import { GlBadge, GlTab, GlTabs, GlLoadingIcon } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { s__ } from '~/locale';
import CancelJobs from '../../admin/jobs_table/components/cancel_jobs.vue?vue3';
import { limitedCounterWithDelimiter } from '~/lib/utils/text_utility';
import { BRIDGE_KIND } from '../constants';
export default {
    name: 'JobsTableTabs',
    components: {
        GlBadge,
        GlTab,
        GlTabs,
        GlLoadingIcon,
        CancelJobs
    },
    inject: {
        jobStatuses: {
            default: {}
        },
        url: {
            type: String,
            default: ''
        }
    },
    props: {
        allJobsCount: {
            type: Number,
            required: true
        },
        loading: {
            type: Boolean,
            required: true
        },
        showCancelAllJobsButton: {
            type: Boolean,
            required: false,
            default: false
        },
        filters: {
            type: Object,
            required: false,
            default: ()=>{}
        }
    },
    emits: [
        'fetch-jobs-by-status'
    ],
    computed: {
        tabs () {
            return [
                {
                    text: s__('Jobs|All'),
                    count: limitedCounterWithDelimiter(this.allJobsCount),
                    scope: null,
                    testId: 'jobs-all-tab',
                    showBadge: this.filters?.kind !== BRIDGE_KIND
                },
                {
                    text: s__('Jobs|Finished'),
                    scope: [
                        this.jobStatuses.success,
                        this.jobStatuses.failed,
                        this.jobStatuses.canceled
                    ],
                    testId: 'jobs-finished-tab',
                    showBadge: false
                }
            ];
        },
        showLoadingIcon () {
            return this.loading && !this.allJobsCount;
        }
    }
};
